import { ASYNC_SEARCH } from '@riophae/vue-treeselect';

import {
  createDebouncedProductSearchExecutor,
  isProductSearchSkipped,
} from '@/utils/productSearch';

/**
 * Mixin debounce + abort cho vue-treeselect product search.
 * Component cần implement: fetchProductSearchApi(searchQuery, options) -> Promise<{ data: [] }>
 * Tuỳ chọn: beforeProductSearchFetch(searchQuery) -> false để chặn (vd. chưa chọn store)
 */
export default {
  created() {
    this._productSearchExecutor = createDebouncedProductSearchExecutor((searchQuery, options) =>
      this.fetchProductSearchApi(searchQuery, options),
    );
  },
  beforeDestroy() {
    this._productSearchExecutor?.cancel?.();
  },
  methods: {
    loadOptionProductsDebounced({ action, searchQuery, callback }) {
      if (action !== ASYNC_SEARCH) {
        return;
      }
      if (!searchQuery?.trim()) {
        callback(null, []);
        return;
      }
      if (isProductSearchSkipped(searchQuery)) {
        callback(null, []);
        return;
      }
      if (this.beforeProductSearchFetch?.(searchQuery) === false) {
        callback(null, []);
        return;
      }
      this._productSearchExecutor.run(searchQuery, (error, result) => {
        if (error) {
          callback(error, []);
          return;
        }
        const options = this.mapProductSearchOptions?.(result) ?? [];
        callback(null, options);
      });
    },
  },
};
